import React from "react";
import { Trans } from "react-i18next";
import "../../styles/components/Admin/ProfileDetails.scss";
import i18next from "i18next";
import Utility from "src/utility/Utility";
interface ProfileDetailsType {
  profileTitleKey: string;
  contentData: any[];
  isStateAdmin?: boolean;
}
interface DataListType {
  dataList: string[];
  isAdmin?: boolean;
}

const DataList = ({ dataList, isAdmin }: DataListType) => {
  const styles = Utility.setStylesUL(dataList.length);

  return (
    <ul style={isAdmin ? styles : {}}>
      {dataList.map((data, index) => {
        return data ? (
          <li key={data.toString()}>{data}</li>
        ) : (
          <li key={`NA-${index}`}>
            <Trans i18nKey={"unavailable"} />
          </li>
        );
      })}
    </ul>
  );
};

const ProfileDetailsTranslations = ({
  profileTitleKey,
  contentData,
  isStateAdmin,
}: ProfileDetailsType) => {
  return (
    <>
      <div className="profileDetailsTitle">
        <span>
          <Trans i18nKey={profileTitleKey}></Trans>
        </span>
      </div>
      <div className="profileDetailsContentContainer text-capitalize">
        {contentData.map(contentDataItem => {
          if (!contentDataItem.data) {
            return (
              <div
                key={contentDataItem.title}
                className="profileDetailsContent"
              >
                <div className="contentDetailsTitle">
                  <Trans i18nKey={contentDataItem.title}></Trans>
                </div>
                <div className="contentDetailsData">
                  <Trans i18nKey={"unavailable"} />
                </div>
              </div>
            );
          }
          if (contentDataItem.data !== "undefined") {
            const chunks: any = Utility.createChunkSet(contentDataItem.data);
            const titleCLass =
              contentDataItem?.title_key == "list_of_district"
                ? "contentDetailsTitle mb-2"
                : "contentDetailsTitle";
            return (
              <div
                key={contentDataItem.title}
                className="profileDetailsContent"
              >
                <div className={titleCLass}>
                  <Trans i18nKey={contentDataItem.title}></Trans>
                  {contentDataItem.title == "list_of_district" && (
                    <span className="contentCount">
                      {` (${contentDataItem.data.length} ${i18next.t(
                        "grid.district"
                      )})`}
                    </span>
                  )}
                </div>
                <div className="row">
                  {chunks &&
                    chunks.map((chunk: any) => {
                      return (
                        <div className="col-md-3">
                          {chunk &&
                            chunk.map((item: string) => {
                              return (
                                <div className="contentDetailsData">{item}</div>
                              );
                            })}
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          } else {
            return (
              <div
                key={contentDataItem.title}
                className="profileDetailsContent"
              >
                <div className="contentDetailsTitle">
                  <Trans i18nKey={contentDataItem.title}></Trans>
                  {isStateAdmin &&
                    `(${
                      contentDataItem.data && contentDataItem.data.length
                    } ${i18next.t("grid.district")})`}
                </div>
                <div className="contentDetailsData">
                  <DataList
                    dataList={contentDataItem.data}
                    isAdmin={isStateAdmin}
                  />
                </div>
              </div>
            );
          }
        })}
      </div>
    </>
  );
};

export default ProfileDetailsTranslations;
